import { render, staticRenderFns } from "./ParticipationRuleSection.vue?vue&type=template&id=529cb72e&"
import script from "./ParticipationRuleSection.vue?vue&type=script&lang=js&"
export * from "./ParticipationRuleSection.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationRuleSection.vue?vue&type=style&index=0&id=529cb72e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports